/* global axios */
import ApiClient from './ApiClient';

class LeadsAPI extends ApiClient {
  constructor() {
    super('leads', { accountScoped: true });
  }

  get({ page = 1, status = '', category = '', conversationId } = {}) {
    return axios.get(this.url, {
      params: { page, status, category, conversation_id: conversationId },
    });
  }
}

export default new LeadsAPI();
